import './geolocation.css';

function GeolocationButton(props) {
    return (
        <div className={`geolocation ${props.className} ${!props.haveLocation ? 'geolocation-disabled' : ''}`}>
            <button onClick={props.handleGeolocationClick} className={'slo-btn'} type="button">Proche de moi {props.range ? `( ≈ ${props.range}km )`:''}</button>
        </div>
    );
}

export default GeolocationButton;
